"use strict";
var root = require('./_root');
var coreJsData = root['__core-js_shared__'];
module.exports = coreJsData;
//# sourceMappingURL=_coreJsData.js.map